import React from "react";
import "../styles/PrivacyPolicies.css";

const About = () => {
  return (
    <div class="privacy-policies-container">
      <section >
        <div class="content-body d-flex justify-content-center align-items-center ht-500">
          <div class="shadow p-4 rounded bg-white">
            <h1 class="center content-header">Privacy Policy for Nimble</h1>
            <div class="scrollable-wrapper">
              <p class="content-text">
                <strong>Privacy Policy for Nimble</strong><br />
                <em>Effective Date: April 9, 2025</em><br /><br />

                Motura Inc. d/b/a Nimble ("Motura", "Nimble", "we", "us", or "our") is committed to protecting your privacy and providing transparency regarding how we collect, use, share, and safeguard your Personal Information. This Privacy Policy ("Policy") applies to our mobile applications, websites, in-store functionalities (such as Scan & Pay and Snap & Pay), Order Pickup services, personalized recipe recommendations, AI-generated content features, and any other related services (collectively, the "Services").<br /><br />

                <hr />

                <strong>Table of Contents</strong><br />
                <ol>
                  <li><a href="#introduction">Introduction</a></li>
                  <li><a href="#info-collect">Information We Collect</a>
                    <ul>
                      <li>Information You Provide</li>
                      <li>Information Collected Automatically</li>
                      <li>Information from Third Parties</li>
                    </ul>
                  </li>
                  <li><a href="#info-use">How We Use Your Information</a></li>
                  <li><a href="#info-sharing">Information Sharing and Disclosure</a></li>
                  <li><a href="#privacy-rights">Your Privacy Rights and Choices</a></li>
                  <li><a href="#security">Security and Data Retention</a></li>
                  <li><a href="#intl-transfers">International Data Transfers</a></li>
                  <li><a href="#special-considerations">Special Considerations for Unique Services</a>
                    <ul>
                      <li>AI-Generated Content</li>
                      <li>In-Store Features and Order Pickup</li>
                      <li>Personalized Recipe Recommendations</li>
                    </ul>
                  </li>
                  <li><a href="#regional">Regional Disclosures and Legal Requirements</a></li>
                  <li><a href="#children">Children's Privacy</a></li>
                  <li><a href="#third-party">Third-Party Websites and Links</a></li>
                  <li><a href="#changes">Changes to This Privacy Policy</a></li>
                  <li><a href="#contact">Contact Information</a></li>
                </ol>

                <div id="introduction">
                  <strong>1. Introduction</strong><br />
                  Motura Inc. d/b/a Nimble offers an innovative platform designed to streamline your shopping experience through features such as mobile payment scanning, personalized recipe recommendations, and convenient order pickup at retail locations. This Policy describes how we collect, use, and share your Personal Information when you interact with our Services. By accessing or using our Services, you agree to this Policy and the practices described herein.<br /><br />
                </div>

                <hr />

                <div id="info-collect">
                  <strong>2. Information We Collect</strong><br />
                  
                  <strong>(a) Information You Provide</strong><br />
                  When you interact directly with our Services, we collect information such as:
                  <ul>
                    <li><strong>Contact and Account Information:</strong> Your name, email address, telephone number, physical address (for shipping or work), username, password, and other account details.</li>
                    <li><strong>Order Information:</strong> Details necessary to process and fulfill your orders, including order items, special instructions, delivery addresses, and timestamps.</li>
                    <li><strong>Payment Information:</strong> Billing addresses and payment method details (note that sensitive payment data is processed by our third-party payment processors).</li>
                    <li><strong>Identity and Age Verification Data:</strong> For age-restricted orders (e.g., alcohol purchases), we collect government-issued ID data or other verification information.</li>
                    <li><strong>Preferences and Profile Data:</strong> Any preferences you set (for personalized recipe recommendations or other features) and content you choose to share (such as reviews or photos).</li>
                  </ul><br />

                  <strong>(b) Information Collected Automatically</strong><br />
                  When you use our Services, we automatically collect:
                  <ul>
                    <li><strong>Device and Technical Data:</strong> Your IP address, device type, operating system, browser type, unique device identifiers, and other technical details.</li>
                    <li><strong>Usage and Activity Data:</strong> Information regarding your sessions (pages visited, interactions such as clicks and scrolls, session replays) and the duration and frequency of your use of our Services.</li>
                    <li><strong>Geolocation Information:</strong> Precise or approximate location data (if you permit location access) to facilitate in-store features and ensure accurate order pickups.</li>
                    <li><strong>Cookies and Similar Technologies:</strong> Data collected via cookies, pixels, tags, and similar tracking mechanisms used for usage analysis and personalizing your experience.</li>
                  </ul><br />

                  <strong>(c) Information from Third Parties</strong><br />
                  We may also receive Personal Information about you from:
                  <ul>
                    <li><strong>Service Providers and Partners:</strong> Third parties that assist in delivering our services (e.g., payment processors, analytics providers, marketing partners).</li>
                    <li><strong>Retail and Business Partners:</strong> Information shared through interactions with retail partners for features like Order Pickup.</li>
                    <li><strong>Social and Co-Branded Platforms:</strong> Data obtained via third-party authentication services (e.g., Facebook, Google) or partner platforms.</li>
                  </ul><br />
                </div>

                <hr />

                <div id="info-use">
                  <strong>3. How We Use Your Information</strong><br />
                  We use your Personal Information for various purposes, including to:
                  <ul>
                    <li><strong>Deliver and Manage Services:</strong> Process orders, facilitate payments, and support features such as Scan & Pay, Order Pickup, and AI-generated content.</li>
                    <li><strong>Personalize Your Experience:</strong> Tailor content such as recipe recommendations and user-specific offers based on your interactions and preferences.</li>
                    <li><strong>Enhance and Innovate:</strong> Analyze usage trends and behavior to improve our Services and develop new features.</li>
                    <li><strong>Communicate with You:</strong> Provide updates, customer support, promotional materials (when consented to), and service-related notifications.</li>
                    <li><strong>Ensure Security and Prevent Fraud:</strong> Protect against unauthorized access, verify user identity, and detect fraudulent activity.</li>
                    <li><strong>Meet Legal Obligations:</strong> Comply with applicable laws and respond to lawful requests from authorities.</li>
                  </ul><br />
                </div>

                <hr />

                <div id="info-sharing">
                  <strong>4. Information Sharing and Disclosure</strong><br />
                  We may share your Personal Information in the following ways:
                  <ul>
                    <li><strong>With Service Providers:</strong> Such as payment processors, cloud storage services, marketing and analytics providers, and security vendors who are bound by confidentiality agreements.</li>
                    <li><strong>With Retail and Business Partners:</strong> Especially for facilitating in-store functionalities and Order Pickup services.</li>
                    <li><strong>For Legal Purposes:</strong> To comply with legal obligations, respond to court orders, or protect our rights and those of our users.</li>
                    <li><strong>In Corporate Transactions:</strong> In connection with mergers, acquisitions, or asset sales, your information may be transferred to successor entities.</li>
                    <li><strong>Public Sharing:</strong> When you choose to share content publicly (e.g., reviews, recipes) on our platform.</li>
                  </ul><br />
                </div>

                <hr />

                <div id="privacy-rights">
                  <strong>5. Your Privacy Rights and Choices</strong><br />
                  Depending on your jurisdiction, you may have certain rights regarding your Personal Information:
                  <ul>
                    <li><strong>Access and Portability:</strong> Request access to your data in a machine-readable format.</li>
                    <li><strong>Correction and Deletion:</strong> Request corrections or deletion of your Personal Information (subject to legal or operational restrictions).</li>
                    <li><strong>Opt-Out Options:</strong> Manage your preferences for receiving marketing communications and opt out of data sharing for targeted advertising.</li>
                    <li><strong>Withdrawal of Consent:</strong> Withdraw consent for certain processing activities, though this may affect service functionality.</li>
                  </ul>
                  You can exercise these rights through our in-app "Account Settings" or by contacting us as described in Section 13 below. We will verify your identity where necessary before processing your request.<br /><br />
                </div>

                <hr />

                <div id="security">
                  <strong>6. Security and Data Retention</strong><br />
                  <ul>
                    <li><strong>Security Measures:</strong> We implement industry-standard administrative, technical, and physical safeguards to protect your Personal Information. Although we strive to maintain data security, no method is completely secure.</li>
                    <li><strong>Data Retention:</strong> We retain your Personal Information only as long as necessary to fulfill the purposes outlined in this Policy or as required by law. Retention durations are based on the type and sensitivity of data, the nature of your interactions with our Services, and applicable legal obligations.</li>
                  </ul><br />
                </div>

                <hr />

                <div id="intl-transfers">
                  <strong>7. International Data Transfers</strong><br />
                  Your Personal Information may be processed and stored on systems located in various countries. When transferring data across borders, we implement adequate safeguards to ensure that your information is protected in accordance with this Policy and applicable laws.<br /><br />
                </div>

                <hr />

                <div id="special-considerations">
                  <strong>8. Special Considerations for Unique Services</strong><br />
                  
                  <strong>(a) AI-Generated Content</strong><br />
                  <ul>
                    <li><strong>Nature of AI Outputs:</strong> Certain features of our Services use artificial intelligence to generate content such as personalized recipe suggestions and product recommendations. These outputs are provided "as is" without warranties regarding their accuracy or completeness.</li>
                    <li><strong>User Responsibility:</strong> We advise you to verify any critical decisions (especially those affecting health, safety, or financial matters) before relying solely on AI-generated results.</li>
                  </ul><br />

                  <strong>(b) In-Store Features and Order Pickup</strong><br />
                  <ul>
                    <li><strong>Functionality:</strong> Our in-store functionalities (Scan & Pay, Snap & Pay) and Order Pickup services require real-time data (including geolocation and order details) to operate effectively.</li>
                    <li><strong>Data Sharing:</strong> During these interactions, limited information is shared with retail partners strictly to process orders and ensure accurate pickups.</li>
                  </ul><br />

                  <strong>(c) Personalized Recipe Recommendations</strong><br />
                  <ul>
                    <li><strong>Customization:</strong> We analyze your purchase history, preferences, and interactions to provide customized recipe suggestions.</li>
                    <li><strong>Informational Use:</strong> Recipe recommendations are offered solely for informational purposes and are not intended to replace professional advice related to nutrition, health, or dietary needs.</li>
                  </ul><br />
                </div>

                <hr />

                <div id="regional">
                  <strong>9. Regional Disclosures and Legal Requirements</strong><br />
                  We comply with applicable privacy laws in various jurisdictions. Depending on your location, additional rights and disclosures may apply:
                  <ul>
                    <li><strong>United States:</strong> For example, specific provisions under the California Consumer Privacy Act (CCPA) are provided for California residents.</li>
                    <li><strong>Canada:</strong> Residents in Canada, including those subject to provincial data protection laws (such as PIPEDA), are afforded specific rights, such as access and deletion.</li>
                    <li><strong>European Union and EEA:</strong> If you are located in the European Economic Area, your data is processed under the General Data Protection Regulation (GDPR).</li>
                  </ul>
                  For detailed instructions on exercising your rights based on your regional laws, please contact us using the information below.<br /><br />
                </div>

                <hr />

                <div id="children">
                  <strong>10. Children's Privacy</strong><br />
                  Our Services are not intended for individuals under the age of 18. We do not knowingly collect Personal Information from children under 18. If you believe that we have inadvertently collected data from a minor, please contact us immediately so that we can address the issue.<br /><br />
                </div>

                <hr />

                <div id="third-party">
                  <strong>11. Third-Party Websites and Links</strong><br />
                  Our Services may include links to third-party websites, applications, or services that are not controlled by Nimble. We are not responsible for the privacy practices of these third parties and recommend that you review their respective privacy policies before sharing any Personal Information.<br /><br />
                </div>

                <hr />

                <div id="changes">
                  <strong>12. Changes to This Privacy Policy</strong><br />
                  We may update this Policy periodically to reflect changes in our practices or legal requirements. When material changes occur, we will update the Effective Date and, where necessary, notify you via the Services or by other appropriate means. We encourage you to review this Policy periodically to stay informed about how we protect your data.<br /><br />
                </div>

                <hr />

                <div id="contact">
                  <strong>13. Contact Information</strong><br />
                  If you have any questions, concerns, or requests regarding this Privacy Policy or our privacy practices, please contact our Privacy Office at:<br /><br />
                  
                  Motura Inc. d/b/a Nimble<br />
                  Attn: Privacy Office<br /><br />
                  
                  Email: <a href="mailto:privacy@getnimbleapp.com">privacy@getnimbleapp.com</a><br /><br />
                  
                  For any rights requests, please reach out using the above contact information. We will respond in accordance with applicable law.<br /><br />
                </div>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default About;
